<script setup>
  import { computed, ref } from "vue";
  import { useNoteTypeStore } from "@/stores/useNoteTypeStore";
  import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";
  
  const emit = defineEmits(["close"]);
  const noteTypeStore = useNoteTypeStore();
  
  // Quantidade "viva" (pode mudar durante o delete)
  const selectedCount = computed(() => noteTypeStore.selectedNoteTypeIds.length);
  
  // ✅ Congela o valor ao abrir o modal (evita trocar plural -> singular)
  const frozenCount = ref(selectedCount.value);
  if (!frozenCount.value || frozenCount.value < 1) frozenCount.value = 1;
  
  // ===============================
  // ✅ Tratamento de erro específico
  // ===============================
  function buildBatchNoteTypeDeleteError(error) {
    const raw =
      error?.response?.data?.message ||
      error?.message ||
      "";
  
    let userFriendlyMessage =
      "Ocorreu um erro ao tentar excluir as CATEGORIAS DE NOTA em lote.";
  
    if (raw) userFriendlyMessage = raw;
  
    const looksLikeFK =
      raw.includes("foreign key constraint fails") ||
      raw.toLowerCase().includes("constraint") ||
      raw.toLowerCase().includes("foreign key");
  
    if (looksLikeFK) {
      userFriendlyMessage =
        "Uma ou mais categorias de nota selecionadas estão vinculadas a Subtipos de Nota e não podem ser removidas.\nPara excluí-las, remova primeiro todos os subtipos associados a estas categorias de nota.";
    }
  
    return userFriendlyMessage;
  }
  
  const messageTitle = computed(() => {
    // ✅ usa frozenCount (não muda depois de clicar em apagar)
    if (frozenCount.value === 1) {
      return "Tem certeza que deseja excluir esta categoria de nota?";
    }
    return `Tem certeza que deseja excluir ${frozenCount.value} categorias de nota?`;
  });
  
  // ===========================================
  // ✅ onConfirm: executa e deixa o modal cuidar
  // ===========================================
  async function onConfirmBatchDelete() {
    try {
      await noteTypeStore.deleteSelectedNoteTypes();
  
      // mantém exatamente seu comportamento atual
      noteTypeStore.shouldForcePageOne = true;
    } catch (error) {
      const msg = buildBatchNoteTypeDeleteError(error);
      throw new Error(msg);
    }
  }
  </script>
  
  <template>
    <DeleteConfirmModal
      :show="true"
      title="Apagar Categorias de Notas em Lote"
      :messageTitle="messageTitle"
      messageSubtitle="Esta ação não pode ser desfeita."
      confirmText="Sim, apagar"
      cancelText="Cancelar"
      loadingText="Apagando..."
      :onConfirm="onConfirmBatchDelete"
      @close="emit('close')"
    />
  </template>
  